// Display helpers for the POS pages. Money is integer paise everywhere; it
// becomes rupees here and only here, by integer arithmetic (no float maths on
// a figure). Dates are shown in India's zone because every business date the
// cloud holds is an India date.

export function formatRupees(paise: number | null | undefined): string {
  if (paise === null || paise === undefined) return '—';
  const negative = paise < 0;
  const abs = Math.abs(paise);
  const rupees = Math.trunc(abs / 100);
  const rest = String(abs % 100).padStart(2, '0');
  // Indian digit grouping: last three, then twos.
  const digits = String(rupees);
  const grouped =
    digits.length <= 3
      ? digits
      : `${digits.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',')},${digits.slice(-3)}`;
  return `${negative ? '−' : ''}₹${grouped}.${rest}`;
}

const dateTime = new Intl.DateTimeFormat('en-IN', {
  timeZone: 'Asia/Kolkata',
  day: '2-digit',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : dateTime.format(d);
}

/** Today's calendar date in India, `YYYY-MM-DD`. */
export function todayInIndia(now: Date = new Date()): string {
  return new Date(now.getTime() + 19_800_000).toISOString().slice(0, 10);
}

/** `bill_flag_total_mismatch` → `total mismatch`, `pending_approval` → `pending approval`. */
export function humanize(code: string): string {
  return code.replace(/^bill_flag_/, '').replace(/_/g, ' ');
}

/**
 * Who did something, from a till's actor ref and the name the staff list has for it
 * (slice 82). A person the list does not know is shown by what the ref says, never by a guess.
 */
export function actorLabel(ref: string, name: string | null): string {
  if (name) return name;
  if (ref.startsWith('staff:')) return 'A person not on the staff list';
  if (ref.startsWith('device:')) return 'The till itself';
  return 'Unknown';
}
